// Airlines for the "Global airline coverage" marquee.
// Logos are sourced from Kiwi's public airline logo CDN (https://images.kiwi.com/airlines/{size}/{IATA}.png).
// This is illustrative only and does not imply any partnership or contract.
const AIRLINES = [
  { code: "SQ", name: "Singapore Airlines" },
  { code: "QR", name: "Qatar Airways" },
  { code: "EK", name: "Emirates" },
  { code: "LH", name: "Lufthansa" },
  { code: "BA", name: "British Airways" },
  { code: "AF", name: "Air France" },
  { code: "KL", name: "KLM" },
  { code: "TK", name: "Turkish Airlines" },
  { code: "EY", name: "Etihad Airways" },
  { code: "AI", name: "Air India" },
  { code: "TG", name: "Thai Airways" },
  { code: "UL", name: "SriLankan Airlines" },
  { code: "6E", name: "IndiGo" },
  { code: "AK", name: "AirAsia" },
  { code: "TR", name: "Scoot" },
  { code: "FZ", name: "flydubai" },
  { code: "U2", name: "easyJet" },
  { code: "FR", name: "Ryanair" },
];

const logoSrc = (code) => `https://images.kiwi.com/airlines/64/${code}.png`;

export default function AirlineMarquee() {
  // Duplicate the list so the seamless loop translates -50%
  const loop = [...AIRLINES, ...AIRLINES];

  return (
    <section
      className="gd-page"
      style={{ padding: "8px 24px 72px" }}
      data-testid="airline-coverage-section"
    >
      <div style={{ textAlign: "center", maxWidth: 680, margin: "0 auto 28px" }}>
        <span className="gd-small-caps">Coverage</span>
        <h2
          style={{
            fontSize: 28,
            fontWeight: 600,
            letterSpacing: "-0.02em",
            margin: "8px 0 10px",
          }}
          data-testid="airline-coverage-title"
        >
          Global airline coverage
        </h2>
        <p
          style={{
            color: "var(--text-muted)",
            fontSize: 15,
            margin: 0,
            lineHeight: 1.6,
            maxWidth: 620,
            marginInline: "auto",
          }}
        >
          Reservations may be created across leading international full-service and low-cost
          carriers, subject to route and availability.
        </p>
      </div>

      <div className="gd-marquee" data-testid="airline-marquee" aria-label="Airline coverage">
        <div className="gd-marquee-track">
          {loop.map((a, i) => (
            <div
              key={`${a.code}-${i}`}
              className="gd-marquee-item"
              title={a.name}
              data-testid={i < AIRLINES.length ? `airline-${a.code}` : undefined}
            >
              <img
                src={logoSrc(a.code)}
                alt={a.name}
                loading="lazy"
                onError={(e) => {
                  // Fallback: hide broken image so wordmark still shows
                  e.currentTarget.style.display = "none";
                  const parent = e.currentTarget.parentElement;
                  if (parent && !parent.querySelector(".gd-fallback-name")) {
                    const span = document.createElement("span");
                    span.className = "gd-fallback-name";
                    span.style.fontSize = "13px";
                    span.style.fontWeight = "600";
                    span.style.color = "#9ca3af";
                    span.style.letterSpacing = "-0.01em";
                    span.textContent = a.name;
                    parent.appendChild(span);
                  }
                }}
              />
              <span className="gd-marquee-name">{a.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
